import { inject } from '@angular/core';
import { ResolveFn, Router, UrlTree } from '@angular/router';
import { Store } from '@ngxs/store';
import { AuthSelectors } from '@states/auth/auth.selectors';
import { User } from '../models/core.models';

/**
 * Profile resolver - returns current user profile synchronously
 * Redirects to sign-in if not authenticated
 *
 * No waiting, no delays - instant synchronous check
 */
export const profileResolver: ResolveFn<User | UrlTree> = (_route, state) => {
  const store = inject(Store);
  const router = inject(Router);

  // Synchronous snapshot - instant, no delays
  const user = store.selectSnapshot(AuthSelectors.getUser);

  // Redirect to sign-in if not authenticated
  if (!user) {
    return router.createUrlTree(['/sign-in'], {
      queryParams: { returnUrl: state.url },
    });
  }

  return user;
};
